import React from "react";
import Colors from "lookup/Colors.json";
import { formatDateWithTime } from "services/MomentUtils";
import {
  ActivityEvents,
  closeReasonDisplayEnabledForEvents,
} from "lookup/AgentWorkspaceConstants";
import { formatDateForDisplay } from "services/MomentUtils";
import { isStringEmptyOrNull } from "services/UtilityService";
import { Col, Row } from "react-bootstrap";
import { Timeline } from "plugins/Timeline/Timeline";

const colorMapForEvents = {
  [ActivityEvents.ESCALATE]: Colors["yellow"],
  [ActivityEvents.ADDED_TO_AW]: Colors["rm-success"],
  [ActivityEvents.HOLD]: Colors["rm-gray-dark"],
  [ActivityEvents.DEESCALATE]: Colors["orange"],
  [ActivityEvents.EXTERNAL_CHANGE]: Colors["yellow"],
  [ActivityEvents.REOPEN]: Colors["green"],
  [ActivityEvents.CLOSE]: Colors["rm-danger"],
  [ActivityEvents.UPDATE_STATE]: Colors["rm-blue"],
  [ActivityEvents.RESCHEDULE]: Colors["rm-blue"],
  [ActivityEvents.FAX_UNLINKED]: Colors["rm-danger"],
};

const ActivityTimeline = (props) => {
  const { activityEvents } = props;
  return (
    <Timeline className="big-top-space">
      {activityEvents.map((activityEvent, i) => {
        const color = colorMapForEvents[activityEvent.event];
        return (
          <div
            key={i}
            id={"timelineItemTitleContainer " + activityEvent.creationDate}
            className="vertical-timeline-element"
          >
            <span
              className="vertical-timeline-element-icon"
              style={{ background: color, color: Colors["rm-white"] }}
            />
            <div className="vertical-timeline-element-content">
              <div
                className="vertical-timeline-element-content-arrow"
                style={{
                  borderRight: `7px solid ${color}`,
                }}
              />
              <span
                className="vertical-timeline-element-date grouped-state-title"
              >
                {formatDateWithTime(activityEvent.creationDate)}
              </span>
              <span>
                <Row>
                  <Col md={6}>
                    <div
                      className="pull-left"
                      style={{
                        color,
                        fontSize: "1.1em",
                      }}
                    >
                      <strong>{activityEvent.event}</strong>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div
                      className="pull-right"
                      style={{
                        color,
                      }}
                    >
                      <strong>{activityEvent.name}</strong>
                    </div>
                  </Col>
                </Row>
                <div className="text-mute">
                  {!isStringEmptyOrNull(activityEvent.activityName) ? (
                    <>
                      <strong>Activity Name:</strong>{" "}
                      {activityEvent.activityName}
                    </>
                  ) : null}
                </div>
                <div className="text-mute">
                  {!isStringEmptyOrNull(activityEvent.state) ? (
                    <>
                      <strong>State:</strong> {activityEvent.state}
                    </>
                  ) : null}
                </div>
                <div className="text-mute">
                  {closeReasonDisplayEnabledForEvents(activityEvent.event) &&
                  !isStringEmptyOrNull(activityEvent.closeReason) ? (
                    <>
                      <strong>Close Reason:</strong>{" "}
                      {activityEvent.closeReason}
                    </>
                  ) : null}
                </div>
                <div className="text-mute">
                  <strong>Priority:</strong> {activityEvent.priority}
                </div>
                <div className="text-mute">
                  <strong>Scheduled Date:</strong>{" "}
                  {formatDateForDisplay(activityEvent.scheduledDate)}
                </div>
                <div className="text-mute">
                  {!isStringEmptyOrNull(activityEvent.taskReason) ? (
                    <>
                      <strong>Task Reason:</strong>{" "}
                      {activityEvent.taskReason}
                    </>
                  ) : null}
                </div>
                <div className="text-mute">
                  {!isStringEmptyOrNull(activityEvent.note) ? (
                    <>
                      <strong>Note:</strong> {activityEvent.note}
                    </>
                  ) : null}
                </div>
              </span>
            </div>
          </div>
        );
      })}
    </Timeline>
  );
};

export default ActivityTimeline;
